import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link, useLocation  } from "react-router-dom";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import MFADialog from "./MFADialog/index";
import errorSign from '../../assets/images/errorSign.svg';
import './style.scss';
import { Validation } from '../../Validation/Validation';
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { loginUser } from "../../Actions/SigninPageAction";

const SigninPage = () => {
  const dispatch = useDispatch();

  const { token, error, mfaRequired } = useSelector((state) => state.signinPage);

  const [formData, setFormData] = useState({ username: '', password: '' });
  const [formError, setFormError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showMFADialog, setShowMFADialog] = useState(false);
  const [closeModalValidation, setCloseModalValidation] = useState(false);
  const location = useLocation();
    const navigate = useNavigate();
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleValidation = () => {
    if (Validation.empty(formData.username)) {
      setFormError("Please enter your Username");
      return false;
    }
    if (Validation.empty(formData.password)) {
      setFormError("Please enter your Password");
      return false;
    }
    return true;
  };

  const getDeviceId = async () => {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    return result.visitorId;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!handleValidation()) {
      setShowError(true);
      return;
    }
    dispatch(loginUser(formData, getDeviceId, navigate));
  };

  const handleClose = () => {
    setShowMFADialog(false);
    setCloseModalValidation(false);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    if (error) {
      setFormError(error);
      setShowError(true);
      setTimeout(() => {
        setShowError(false);
        setFormError("");
      }, 5000);
    }
  }, [error]);

  useEffect(() => {
    if(token) {
      localStorage.setItem("token", JSON.stringify(token));
    }
  } ,[token])

  useEffect(() => {
    if (mfaRequired) {
      setShowMFADialog(true);
      setCloseModalValidation(true);
    }
  }, [mfaRequired]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };
const { state, pathname } = location;

useEffect(() => {
  if (state?.focusLoginButton) {
    setTimeout(() => {
      document.getElementById('username')?.focus();
      navigate(pathname, { replace: true });
    }, 200);
  }
}, [state, pathname, navigate]);
  return (
    <>
      {(showError && formError) && (
        <div className="error_wraper" role="alert" aria-live="assertive" id="errorForLogin">
          <img src={errorSign}  alt="" />
          {formError}
        </div>
      )}
      <div className="right-section">
        <div className="login-form">
          <h1 id="signin-heading">Welcome</h1>
          <form className="field" onSubmit={handleSubmit} aria-labelledby={` ${(showError && formError) ? "signin-heading errorForLogin "  : "signin-heading"  }`}>
            <Box component="div" noValidate autoComplete="off" className="field">
              <TextField
                id="username"
                name="username"
                label="Email/Username"
                variant="outlined"
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
                value={formData.username}
                InputLabelProps={{ shrink: true, style: { transform: 'inherit' } }}
                 InputProps={{
                   style: { borderRadius: '4px' },
                  inputProps: {
                    'aria-required': true,
                    'aria-label': 'Email or Username',
                  },
                }}
                required
              />
                <TextField
                  id="password"
                  name="password"
                  label="Password"
                  type={showPassword ? "text" : "password"}
                  variant="outlined"
                  // data-testid="password-input"
                  onChange={handleInputChange}
                  onKeyPress={handleKeyPress}
                  value={formData.password}
                  InputLabelProps={{
                    shrink: true,
                    style: { transform: 'inherit' },
                  }}
                  InputProps={{
                    style: { borderRadius: '4px' },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={togglePasswordVisibility}
                          edge="end"
                          aria-label={showPassword ? "Hide password" : "Show password"}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                    inputProps: {
                      'aria-required': true,
                      'data-testid': 'password-input',
                    },
                  }}
                  required
                />
            </Box>
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between'
            }}>
              <Link to="/ForgotPassword" className="forgot-password"  aria-label="Forgot password?" >
                Forgot Password?
              </Link>
            </div>
            <button type="submit" className="btnSubmit" aria-label="Sign in">Sign in</button>
          </form>
          <MFADialog
            open={window.location.pathname === '/onboarding-with-license' ? false : showMFADialog}
            setShowMFADialog={setShowMFADialog}
            onClose={handleClose}
            closeModalValidation={closeModalValidation}
            setCloseModalValidation={setCloseModalValidation}
          />
        </div>
      </div>
    </>
  );
};

export default SigninPage;
